/**
 * Where web loads the Rive WASM runtime from: our own origin, never unpkg.
 *
 * The file is a copy of the runtime that ships with the installed web Rive package, and
 * the version in its name must match that package exactly, because a mismatched runtime
 * breaks rendering rather than just slowing it. The deploy headers must name the same
 * path. A unit test holds these together, so a dependency bump without a fresh copy fails
 * the suite.
 *
 * It is the lite runtime, about 60% smaller than the full one, because it leaves out Rive
 * Text and audio. None of our animations use either; one that adds text would render
 * without it, so switch back to the full package before bundling such a file.
 *
 * It is not preloaded. The download waits for the first animation to mount, so pages with
 * no animation never pay for it.
 */
export const RIVE_WASM_URL = '/rive/rive-lite-2.25.0.wasm';
